<template>
  <div>
    <p class="note--label">Recent Note <span v-if="recentNote">from {{ recentNoteDate }}</span></p>
    <p
      v-if="recentNote"
      class="note--body"
      v-html="recentNote.body"
    ></p>
    <p v-else class="note--body is-empty">No recent notes</p>

    <button-outlined
      class="mt-50"
      color="is-secondary"
      @click="$refs.notesModal.open()"
      is-short
    >{{ notes.length ? "View & Add Lead Notes" : "Add First Note" }}
    </button-outlined>

    <modal-container>
      <modal-default
        ref="notesModal"
        title="Lead Notes"
      >
        <notes-default :noteable="record"></notes-default>

        <contacting-note
          v-for="note in notes"
          :key="note.id"
          :note="note"
        ></contacting-note>
      </modal-default>
    </modal-container>
  </div>
</template>

<script>
import ContactingNote from "./ContactingNote";
import dates from "../../../../../services/dates";

export default {
  name: "ContactingBoxNotes",
  components: {ContactingNote},
  props: {
    record: {
      type: Object,
      required: true
    },
    notes: {
      type: Array,
      required: true
    }
  },
  computed: {
    recentNote() {
      return this.notes[0];
    },
    recentNoteDate() {
      if (this.recentNote) return dates.formatAsDate(this.recentNote.created_at);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.note {

  &--label {
    margin-bottom: 2px;
    font-size: 0.75rem;
    color: $text-muted;
    text-transform: uppercase;
  }

  &--body {
    margin-bottom: 8px;
    line-height: 1.3;
    word-wrap: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;

    &.is-empty {
      margin: 10px 0 24px;
      font-style: italic;
    }
  }
}
</style>

